import React from "react";
import { Form, Stack, Input, Button } from "basis";
import requestTempToken from "./utils/requestTempToken";

const validateMerchantID = (id, { isEmpty }) => {
  if (isEmpty(id)) {
    return "Required";
  }

  const MERCHANT_ID_REGEX = /^[a-zA-Z0-9-]{4,20}$/gi;

  if (!Boolean(MERCHANT_ID_REGEX.test(id))) {
    return "Please enter a valid id";
  }

  return null;
};

const InstallForm = ({ initialValues = { merchantID: "" } }) => (
  <Form initialValues={initialValues} method="post" onSubmit={requestTempToken}>
    <Stack gap="4">
      <Input
        name="merchantID"
        color="white"
        label="Your merchant id"
        placeholder="Merchant id"
        pasteAllowed={false}
        min={4}
        max={20}
        validate={validateMerchantID}
      />
      <Button type="submit">Install</Button>
    </Stack>
  </Form>
);

export default InstallForm;
